import { AmplitudeEvent } from "./AmplitudeEvent";

export class TeamMeetingAssignmentEvent extends AmplitudeEvent {
	static SCHEDULE_LOCATION = "schedule";
	static GOALS_TAB_LOCATION = "goals tab";

	constructor( teamName, assignmentLocation ) {
		if ( ![ TeamMeetingAssignmentEvent.SCHEDULE_LOCATION, TeamMeetingAssignmentEvent.GOALS_TAB_LOCATION, ].includes( assignmentLocation ) ) {
			throw new Error( `invalid assignment location: ${assignmentLocation}` );
		}
		super();
		this.name = "Team Assigned to Meeting";
		this.eventProperties.team_name = teamName;
		this.eventProperties.location = assignmentLocation;
	}
}



// WEBPACK FOOTER //
// ./src/telemetry/TeamMeetingAssignmentEvent.js